<template>
  <div>
    <template v-for="(custom_field, index) in form.custom_fields">
      <form-field-custom-field
          v-model="custom_field.value"
          :custom-field-id="custom_field.id"
          :validation-error="(validationErrors[`custom_fields.${index}.value`]) ? validationErrors[`custom_fields.${index}.value`][0] : ''"
          :key="index"
      ></form-field-custom-field>
    </template>
  </div>
</template>

<script>
  import {FormMixin} from "./forms.mixin";
  import {MODELS} from "../services/models";
  import FormFieldCustomField from "../components/form/FormFieldCustomField";

  export default {
    name: "LeadInfoForm",
    components: {FormFieldCustomField},
    props: ['formData'],
    mixins: [FormMixin],
    data() {
      return {
        form: {},
        validationErrors: {},
      }
    },
    created() {
      // This allows you to pass in formData without an id in order to add data to the defaultForm for the the create
      this.form = this.$utils.clone(this.formData);
      this.setCustomFields();
    },
    computed: {
      allCustomFields() {
        // NOTE: If you want to show historical custom fields than change this to recordCustomFieldsWithTrashed
        return this.$store.getters.recordCustomFields;
      },
      canAccessHiddenFields() {
        const authUser = this.$store.getters.authUser;

        if (authUser.is_owner) return true;
        return !!(!authUser.is_owner && authUser.can_access_hidden_lead_custom_fields);
      },
    },
    methods: {
      setCustomFields() {
        this.form.custom_fields = this.allCustomFields.map(customField => {
            const recordField = this.form.custom_fields.find(field => field.id === customField.id);
            if (recordField) {
              return {
                ...recordField,
                hiddenToUser: customField.hidden_to_user
              }
            }

            return {
              class_name: MODELS.CustomFieldJson.class_name,
              id: customField.id,
              value: customField.default_value,
              hiddenToUser: customField.hidden_to_user,
            };
          })
          .filter(customField => !(customField.hiddenToUser && !this.canAccessHiddenFields));
      },
      update() {
        return this.$api.records.updateLeadInfo(this.form)
          .then(res => {
            this.$buefy.toast.open({
              message: 'Lead info was updated',
              type: 'is-success'
            });

            return res;
          });
      },
    },
  }
</script>

<style lang="scss" scoped>

</style>
